import styled from 'styled-components'
import SelectDropdown from '@/components/__Inputs/SelectDropdown'

const StyledDropdown = styled(SelectDropdown)`
  margin-bottom: 20px;
`

export { StyledDropdown }
